








































































import { Component, Prop, Vue } from 'vue-property-decorator';
import DualPriceDisplay from './DualPriceDisplay.vue';
import { UnitIntegrationDetail } from '@/interfaces/unit-integration';

@Component({
    components: { DualPriceDisplay }
})
export default class UnitDetailTable extends Vue {
    @Prop({ required: true }) readonly units!: UnitIntegrationDetail[];
    /** Filas visibles en viewport; el resto con scroll vertical (PAAI-764). */
    @Prop({ default: 3 }) readonly maxVisibleRows!: number;

    readonly rowHeightPx = 68;
    readonly headerHeightPx = 44;

    get scrollContainerStyle(): Record<string, string> {
        if (this.maxVisibleRows < 1 || this.units.length <= this.maxVisibleRows) {
            return {};
        }
        const extraContainerHeight = 12;
        const maxHeight =
            this.headerHeightPx +
            this.maxVisibleRows * this.rowHeightPx +
            extraContainerHeight;
        return {
            maxHeight: `${maxHeight}px`,
            height: `${maxHeight}px`,
            overflowY: 'auto'
        };
    }

    get scrollContainerClass(): Record<string, boolean> {
        return {
            'unit-detail-table__scroll--limited':
                this.maxVisibleRows >= 1 &&
                this.units.length > this.maxVisibleRows
        };
    }

    formatNumber(value?: number | null): string {
        if (value === null || value === undefined) return '-';
        return String(value);
    }

    formatArea(value?: number | null): string {
        if (value === null || value === undefined) return '-';
        return String(value);
    }
}
